import React from "react";
import { Link } from "react-router-dom";

export default function SingleUserSideRoomCard(props) {
  return (
    <Link
      to={`/room/${props.id}`}
      className="single-room-card-userSide text-decoration-none"
    >
      <div
        className="image-side mb-3"
        style={{ background: `url(${props.img})` }}
      ></div>
      <div className="details-side">
        <h4 className="m-0 p-0 text-capitalize">{props.roomName}</h4>
        <p className="mt-2 pt-1 room-desc text-capitalize">
          {`${props.roomDesc.slice(0, 50)}...`}
        </p>
        <p className="mb-2 pb-1 maxPeople">
          <i className="fa-solid fa-user-group me-1"></i>
          <span>{props.roomMaxPeople} Max People</span>
        </p>
        <div className="room-details d-flex align-items-center gap-3">
          <p>
            <i className="fa-solid fa-bed me-1"></i>
            <span>{props.roomBeds} Beds</span>
          </p>
          <p>
            <i className="fa-solid fa-chart-area me-1"></i>
            <span>{props.roomArea} sqft</span>
          </p>
        </div>
        <p className="mb-0 pt-2 room-card-price">
          <span className="price">${props.roomPrice}</span>
          <span className="perDay">/day</span>
        </p>
      </div>
    </Link>
  );
}
